import { Injectable }    from '@angular/core';

import { Plan } from '../../classes/plan';

import { Auth } from '../auth.service';
import { RequestService } from '../request.service';
import { UserService } from '../users/user.service';

@Injectable()
export class PlanService extends UserService {

  constructor(
    protected requestService: RequestService, 
    protected auth: Auth
  ) { super(requestService, auth); }

  protected getUsersUrl(): string {

    return 'plans';
  };

  protected getOneUserUrl(): string {

    return 'plan';
  };

  protected parseObject(obj: any): Plan {

    return obj as Plan;
  };

  protected parseArray(objs: any): Plan[] {

    return objs as Plan[];
  };


}


// WEBPACK FOOTER //
// ./src/app/services/plans/plan.service.ts